import { FC } from "react";
import { CountryDropdown, RegionDropdown } from "react-country-region-selector";
import { StyledRegions } from ".";

export interface ICountriesDropDown {
  countryLabel?: string;
  regionLabel?: string;
  countryValue: string;
  regionValue: string;
  onChangeCountry?: (value: string) => void;
  onChangeRegion?: (value: string) => void;
  // otherProps?: { [key: string]: any };
  // otherCountryProps?: { [key: string]: any };
  // otherRegionProps?: { [key: string]: any };
  className?: string;
  width?: string;
  countryError?: any;
  regionError?: any;
}

export const CountriesDropDown: FC<ICountriesDropDown> = ({
  countryLabel = "Country",
  regionLabel = "Region",
  countryValue,
  regionValue,
  onChangeCountry = () => {},
  onChangeRegion = () => {},
  // otherProps = {},
  // otherCountryProps = {},
  // otherRegionProps = {},
  className = "",
  width = "100%",
  countryError,
  regionError,
}) => {
  return (
    <StyledRegions width={width} className={`flex ${className}`}>
      <div className="container">
        <label htmlFor={"counry"}>{countryLabel}</label>
        <div className="select--container">
          <CountryDropdown
            id={"country"}
            value={countryValue}
            onChange={onChangeCountry}
          />
        </div>
        {countryError && <small className="error">{countryError}</small>}
      </div>
      <div className="container">
        <label htmlFor="region">{regionLabel}</label>
        <div className="select--container">
          <RegionDropdown
            id="region"
            country={countryValue}
            value={regionValue}
            onChange={onChangeRegion}
            blankOptionLabel="Select a country to show regions/states"
          />
        </div>
        {regionError && <small className="error">{regionError}</small>}
      </div>
    </StyledRegions>
  );
};
